import React, { Fragment } from 'react';
import NavigationItem from './NavigationItem';
import MegaMenu from './MegaMenu';
import { useSelector } from 'react-redux';

const Navigation = (props) => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const corpWebEnabled = useSelector((state) => state.toggleSettings.corpWebEnabled);
    const isDesktop = screen.width > 1024;
    const showMegaMenu = isDesktop && corpWebEnabled;
    const showOnlyProductCategories = (corpWebEnabled && isDesktop) || !corpWebEnabled;

    let productCategoryLinks = contentLinks.filter((link) => link?.isProductCategory === true);
    let megaMenuLinks = contentLinks.filter(
        (link) => link?.isProductCategory === false || link?.isProductCategory === undefined
    );

    let links = contentLinks;
    if (
        showOnlyProductCategories &&
        productCategoryLinks &&
        productCategoryLinks.length > 0 &&
        productCategoryLinks[0]?.links
    )
        links = productCategoryLinks[0].links;

    return (
        <Fragment>
            <NavigationItem
                isDesktop={isDesktop}
                links={links}
                {...props}
            />
            {showMegaMenu && megaMenuLinks?.length > 0 && <MegaMenu links={megaMenuLinks} />}
        </Fragment>
    );
};

export default Navigation;
